<ng-container *transloco="let tr; prefix: 'organizations'; scope: 'organizations'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{'organizations.title' | transloco}}</nz-page-header-title>
      <nz-page-header-subtitle>{{'organizations.subTitle' | transloco}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{tr('filter.query')}}</small>
          <input nz-input [(ngModel)]="filter.query" (ngModelChange)="applyFilters(500)">
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table #dataTable [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="title" [nzSortOrder]="columnSortOrderMap.get('title') || null" [nzSortFn]="true"
          [nzSortPriority]="1">{{'organizations.column.title' | transloco}}</th>
      <th nzColumnKey="uin">{{'organizations.column.uin' | transloco}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of dataTable.data">
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle' : 'minus-circle'"
           [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.title | uiLabel }}
      </td>
      <td>{{data.uin}}</td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <a [routerLink]="data.id + '/properties'" nz-button nzType="primary">
            <i nz-icon nzType="setting" nzTheme="outline"></i>
          </a>
          <button (click)="showPaymentAgreementModal(data)" [nz-tooltip]="'organizations.button.showPaymentAgreement' | transloco" nz-button nzType="primary">
            <i nz-icon nzType="file" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
